import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/LandMain.module.css";

const LandMain = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.land_main}>
      <div className={styles.land_main_content} onClick={() => navigate("/products")}>
        <h1>Your Escort Companions</h1>
        <p>Your ultimate pampering experience awaits.</p>
      </div>
    </section>
  );
};

export default LandMain;